import(/* webpackMode: "eager", webpackExports: ["ErrorFallback"] */ "/vercel/path0/app/blog/[slug]/error-fallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedPosts"] */ "/vercel/path0/app/blog/[slug]/related-posts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReturnToBlog"] */ "/vercel/path0/app/blog/[slug]/return-to-blog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundaryWrapper"] */ "/vercel/path0/components/blog/error-boundary-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostInteractions"] */ "/vercel/path0/components/blog/interactions/blog-post-interactions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationButton"] */ "/vercel/path0/components/blog/navigation-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.27.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.27.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
